var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"bg-white"},[_c('OtherLoading',{attrs:{"variant":"dark"}})],1):_c('div',{staticClass:"bg-white pt-4 px-4 coupon-content"},[_c('div',{staticClass:"mt-2 pb-3"},[_c('CouponList',{attrs:{"dataList":_vm.dataList},on:{"getDetails":_vm.getDetails}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }